/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import ESigningApi from "../../pages/ESigningApi";
import ESealingApi from "../../pages/ESealingApi";
import EIdentificationApi from "../../pages/EIdentificationApi";
import AgentApi from "../../pages/AgentApi";
import { NavLink } from "react-router-dom";
import SignatureCollection from "../../pages/SignatureCollection";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";

// icons
import ic_inactive_signature_collection from "../../assets/images/pictures/icon/ic_inactive_signature-collection.svg";
import ic_inactive_signing from "../../assets/images/pictures/icon/ic_inactive_signing.svg";
import ic_inactive_identification from "../../assets/images/pictures/icon/ic_inactive_identification.svg";
import ic_inactive_sealing from "../../assets/images/pictures/icon/ic_inactive_sealing.svg";
import ic_inactive_agent from "../../assets/images/pictures/icon/ic_agent.svg";

import ic_active_signature_collection from "../../assets/images/pictures/icon/ic_active_signature-collection.svg";
import ic_active_signing from "../../assets/images/pictures/icon/ic_active_signing.svg";
import ic_active_identification from "../../assets/images/pictures/icon/ic_active_identification.svg";
import ic_active_sealing from "../../assets/images/pictures/icon/ic_active_sealing.svg";
import ic_active_agent from "../../assets/images/pictures/icon/ic_agent_active.svg";

const SolutionsChildContent = (props) => {
  const { t } = useTranslation();
  const language = useSelector(selectLanguage);
  const [activeTab, setActiveTab] = useState(props.id);

  useEffect(() => {
    setActiveTab(props.id);
  }, [props.id]);

  useEffect(() => {
    if (props.id === "signature-collection") {
      document.title = t(
        "signature-collection-page.signature-collection-page-title"
      );
    } else if (props.id === "e-signing-api") {
      document.title = t("e-signing-api-page.e-signing-api-page-title");
    } else if (props.id === "e-identification-api") {
      document.title = t(
        "e-identification-api-page.e-identification-api-page-title"
      );
    } else if (props.id === "e-sealing-api") {
      document.title = t("e-sealing-api-page.e-sealing-api-page-title");
    } else if (props.id === "agent-api") {
      document.title = t("agent.tab");
    }
  }, [language, props.id, t]);

  const tabs = [
    {
      id: "signature-collection",
      route: "/solutions/signature-collection",
      label: t("solutions-child-page.signature-collection"),
      inactiveIcon: ic_inactive_signature_collection,
      activeIcon: ic_active_signature_collection,
    },
    {
      id: "e-signing-api",
      route: "/solutions/e-signing-api",
      label: t("solutions-child-page.signing"),
      inactiveIcon: ic_inactive_signing,
      activeIcon: ic_active_signing,
    },
    {
      id: "e-identification-api",
      route: "/solutions/e-identification-api",
      label: t("solutions-child-page.identification"),
      inactiveIcon: ic_inactive_identification,
      activeIcon: ic_active_identification,
    },
    {
      id: "e-sealing-api",
      route: "/solutions/e-sealing-api",
      label: t("solutions-child-page.sealing"),
      inactiveIcon: ic_inactive_sealing,
      activeIcon: ic_active_sealing,
    },
    {
      id: "agent-api",
      route: "/solutions/agent",
      label: t("solutions-child-page.Agent"),
      inactiveIcon: ic_inactive_agent,
      activeIcon: ic_active_agent,
    },
  ];

  return (
    <div
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0"
    >
      <div className="tab-content infrastructure-content">
        <nav className="infrastructure-navigation ">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 px-md-0">
                <ul className="list-infrastructure list list-inline text-center">
                  {tabs.map((tab) => (
                    <li
                      key={tab.id}
                      id={`li-${tab.id}`}
                      className={activeTab === tab.id ? "active" : ""}
                    >
                      <NavLink to={tab.route}>
                        <div className="square">
                          <img
                            className="icon inactive-icon"
                            id={`inactive-icon-${tab.id}`}
                            src={tab.inactiveIcon}
                            alt=""
                            style={{
                              display: activeTab === tab.id ? "none" : "block",
                            }}
                          />
                          <img
                            className="icon active-icon"
                            id={`active-icon-${tab.id}`}
                            src={tab.activeIcon}
                            alt=""
                            style={{
                              display: activeTab === tab.id ? "block" : "none",
                            }}
                          />
                        </div>
                        <span>{tab.label}</span>
                        <div className="tab-line"></div>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </nav>
        {/* nội dung các tab */}
        <SignatureCollection following={props.id === "signature-collection"} />
        <ESigningApi following={props.id === "e-signing-api"} />
        <EIdentificationApi following={props.id === "e-identification-api"} />
        <ESealingApi following={props.id === "e-sealing-api"} />
        <AgentApi following={props.id === "agent-api"} />
      </div>
    </div>
  );
};

export default SolutionsChildContent;